import mq from 'js-mq';
import EventEmitter from 'events';
import SyosEvents from './SyosEvents';

const MOBILE_KEY = 'syos-mobile';
const TABLET_KEY = 'syos-tablet';

mq.register([
  { name: MOBILE_KEY, query: '(max-width: 767px)' },
  { name: TABLET_KEY, query: '(max-width: 991px)' },
]);

class SyosMediaQuery extends EventEmitter {
  constructor() {
    super();

    mq.on(MOBILE_KEY, () => {
      this.emit(SyosEvents.MOBILE_ENTER);
    });

    mq.on(`not-${MOBILE_KEY}`, () => {
      this.emit(SyosEvents.MOBILE_LEAVE);
    });

    mq.on(TABLET_KEY, () => {
      this.emit(SyosEvents.TABLET_ENTER);
    });

    mq.on(`not-${TABLET_KEY}`, () => {
      this.emit(SyosEvents.TABLET_LEAVE);
    });
  }

  testIsMobile(): boolean {
    return mq.is(MOBILE_KEY);
  }

  testIsTablet(): boolean {
    return mq.is(TABLET_KEY);
  }
}

export default SyosMediaQuery;
